import { useLocation, useNavigate, Navigate } from "react-router-dom";
import MaterialsPage from "./MaterialsPage";
import InventoryPage from "./InventoryPage";
import MaterialNeedsPage from "./MaterialNeedsPage";
import ReceiptsPage from "./ReceiptsPage";
import FinishedStockPage from "./FinishedStockPage";
import { PurchaseOrdersList } from "../components/PurchaseOrders";
import { PageHeader } from "../components/ui-bits";
import { useT } from "../lib/i18n";

export default function MaterialsInventoryPage() {
  const loc = useLocation();
  const nav = useNavigate();
  const t = useT();
  const params = new URLSearchParams(loc.search);
  const tab = ["inventory", "finished", "needs", "purchases", "receipts"].includes(params.get("tab")) ? params.get("tab") : "materials";

  const setTab = (v) => {
    const p = new URLSearchParams(loc.search);
    p.set("tab", v);
    nav(`/materials-inventory?${p.toString()}`, { replace: false });
  };

  return (
    <div data-testid="materials-inventory-page">
      <PageHeader
        eyebrow={t("materials_inventory.eyebrow")}
        title={tab === "finished" ? "Magazzino prodotti finiti" : tab === "purchases" ? "Ordini ai fornitori" : tab === "receipts" ? "Arrivi merce" : tab === "needs" ? "Fabbisogno materiali" : tab === "inventory" ? t("inventory.title") : t("materials.title")}
        description={tab === "finished" ? "Capi consegnati dalle produzioni, per taglia e colore. Gli ordini Shopify li scalano automaticamente." : tab === "purchases" ? "Merce ordinata ai fornitori e ancora in arrivo." : tab === "receipts" ? "Storico delle consegne ricevute dai fornitori." : tab === "needs" ? "Cosa serve per gli ordini aperti e cosa manca in magazzino." : tab === "inventory" ? t("inventory.desc") : t("materials.desc")}
      />
      <div className="flex gap-1 border-b mb-6 overflow-x-auto whitespace-nowrap [&>button]:shrink-0" style={{ borderColor: "var(--border)" }}>
        <button
          type="button"
          data-testid="tab-materials"
          onClick={() => setTab("materials")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "materials" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "materials" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.materials")}
        </button>
        <button
          type="button"
          data-testid="tab-inventory"
          onClick={() => setTab("inventory")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "inventory" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "inventory" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.inventory")}
        </button>
        <button
          type="button"
          data-testid="tab-finished"
          onClick={() => setTab("finished")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "finished" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "finished" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.finished")}
        </button>

        <button
          type="button"
          data-testid="tab-needs"
          onClick={() => setTab("needs")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "needs" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "needs" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.needs")}
        </button>
        <button
          type="button"
          data-testid="tab-purchases"
          onClick={() => setTab("purchases")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "purchases" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "purchases" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.purchases")}
        </button>
        <button
          type="button"
          data-testid="tab-receipts"
          onClick={() => setTab("receipts")}
          className="px-5 py-3 text-xs uppercase tracking-widest border-b-2"
          style={{
            color: tab === "receipts" ? "var(--text-primary)" : "var(--text-secondary)",
            borderColor: tab === "receipts" ? "var(--text-primary)" : "transparent",
          }}
        >
          {t("tab.receipts")}
        </button>
      </div>
      {tab === "materials" && <MaterialsPage embedded/>}
      {tab === "inventory" && <InventoryPage embedded/>}
      {tab === "needs" && <MaterialNeedsPage/>}
      {tab === "purchases" && <PurchaseOrdersList/>}
      {tab === "receipts" && <ReceiptsPage/>}
      {tab === "finished" && <FinishedStockPage/>}
    </div>
  );
}

export function RedirectToMaterialsTab() { return <Navigate to="/materials-inventory?tab=materials" replace/>; }
export function RedirectToInventoryTab() { return <Navigate to="/materials-inventory?tab=inventory" replace/>; }
